import { History } from 'history';
import * as React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import pageLinks from './utils/pageLinks';
import WithRoot from './WithRoot';
import Dashboard from './pages/Dashboard';
import Updates from './pages/Updates';
// import { ConnectedRouter } from 'connected-react-router';

interface IAppProps {
  history: History;
}

const App = ({ history, ...rest }: IAppProps) => {
  console.log('debug-App', history);
  // https://giters.com/supasate/connected-react-router/issues/543
  // TODO: https://github.com/salvoravida/redux-first-history

  return (
    <WithRoot>
      {/*<ConnectedRouter history={history}>*/}
      <BrowserRouter>
        <Switch>
          {/*<PrivateRoute path={pageLinks.home} component={HomePage} />*/}
          {/*<Route path={pageLinks.home} component={HomePage} />*/}

          <Route path={pageLinks.home} component={Dashboard} />
          <Route path={pageLinks.updates} component={Updates} />

          {/*<Route exact path="/" render={() => (<div>Match</div>)} />*/}
          {/*<Route render={() => (<div>Miss</div>)} />*/}
          {/*<Route path="/:page" component={HomePage} />*/}
        </Switch>
      </BrowserRouter>
      {/*</ConnectedRouter>*/}
      <ToastContainer />
    </WithRoot>
  );
};

/**
const PrivateRoute = ({
  component: Component,
  path,
  ...rest
}: {
  component: React.FC<any>;
  path: string;
}) => {
  const pathname = window.location.pathname;

  function checkToken() {
    const isLogged = isUserLogged();
    if (!isLogged && pathname !== '/login') {
      localStorage.setItem('urlBeforeLogout', window.location.pathname + window.location.search);
    }
    return isLogged;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        checkToken() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
            }}
          />
        )
      }
    />
  );
};
 */

export default App;
